import { render } from "./GradientGraphChart.vue?vue&type=template&id=5e5bbfa5"
import script from "./GradientGraphChart.vue?vue&type=script&lang=js"
export * from "./GradientGraphChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__